import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const eventService = {
  getAllEvents,
  addEvent,
  getEvent,
  deleteEvent
};

function getAllEvents(params) {
  return apiCall("GET", apiUrls.events.base, null, params);
}

function addEvent(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.events.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getEvent(id) {
  return apiCall("GET", `${apiUrls.events.base}/${id}`);
}

function deleteEvent(id) {
  return apiCall("DELETE", `${apiUrls.events.base}/${id}`);
}
